// This is the one allowed use of fetch that allows us to not use it elsewhere
/* eslint-disable no-restricted-globals */

import {parseCsrfTokenFromPage} from './parseCsrfTokenFromPage';

export const supportFetch: typeof fetch = (input, init?) => {
  const csrfToken = parseCsrfTokenFromPage();

  // Construct an augmented headers object that uses all provided headers
  const augmentedHeaders = {
    ...((init && init.headers) || {}),
    'x-stripe-csrf-token': csrfToken,
    'X-Requested-With': 'fetch',
  };

  const augmentedInit = {
    credentials: 'same-origin',
    ...(init || {}),
    headers: augmentedHeaders,
  } as const;

  return fetch(input, augmentedInit);
};
